import BookingDetail from '../features/bookings/bookingDetails/BookingDetail';

function BookingDetails() {
  return <BookingDetail />;
}

export default BookingDetails;
